import { render, staticRenderFns } from "./UserJourneyTimeline.vue?vue&type=template&id=b4de2466&scoped=true&"
import script from "./UserJourneyTimeline.vue?vue&type=script&lang=js&"
export * from "./UserJourneyTimeline.vue?vue&type=script&lang=js&"
import style0 from "./UserJourneyTimeline.vue?vue&type=style&index=0&id=b4de2466&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4de2466",
  null
  
)

export default component.exports